export const scrollState = { progress: 0 }
export const mouseState = { x: 0, y: 0 }
